import React from "react";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdOutlineNavigateBefore,
  MdSettings,
} from "react-icons/md";
import PageTitle from "../../components/PageTitle/PageTitle";
import TwoSidebars from "../../layouts/TwoSidebars/TwoSidebars";
import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import InfoBlock from "../../components/InfoBlock/InfoBlock";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { BUTTON_STYLES, ICON_SIZES } from "../../helpers/constants";
import useMobile from "../../hooks/useMobile";

import SettingsBlocks from "../../components/SettingsBlocks/SettingsBlocks";
import Button from "../../components/Button/Button";
import useGeneralOptionsDropdownMenu from "../../hooks/useGeneralOptionsDropdownMenu";

const AppPermissionsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useMobile();
  const [notificationsAreEnabled, setNotificationsAreEnabled] =
    useState<boolean>(Notification.permission === "granted");
  const generalOptionsDropdown = useGeneralOptionsDropdownMenu();

  return (
    <TwoSidebars
      right={
        isMobile ? null : (
          <SettingsBlocks layout="vertical" columns={isMobile ? 2 : 1} />
        )
      }
    >
      <div className={clsx(["flex", "w-full", "flex-col"])}>
        <PageTitle
          titleLink="/settings"
          icon={<MdSettings size={ICON_SIZES.MD} />}
          title={t("settings.title")}
          subtitle={t("Permisos")}
          isLoading={false}
          rightSide={
            <>
              <ButtonGroup
                align="right"
                gap={1}
                buttons={[
                  {
                    icon: <MdOutlineNavigateBefore size={ICON_SIZES.SM} />,
                    className: isMobile ? BUTTON_STYLES.HEADING : "",
                    tooltip: "Atras",
                    onClick: () => {
                      navigate("/settings");
                    },
                  },
                  generalOptionsDropdown,
                ]}
              />
            </>
          }
        />
        <div className={clsx(["flex", "gap-4", "flex-col"])}>
          <div className={clsx(["flex", "flex-col", "gap-2"])}>
            <div className={clsx(["grid", "grid-cols-1", "gap-4"])}>
              <div className={clsx(["flex", "flex-col", "gap-2"])}>
                {notificationsAreEnabled ? (
                  <InfoBlock
                    message={t(
                      "app_settings_page.notifications_section.description_enabled"
                    )}
                    title={t("app_settings_page.notifications_section.title")}
                  />
                ) : (
                  <Button
                    onClick={async () => {
                      const res = await Notification.requestPermission();
                      setNotificationsAreEnabled(!!res);
                    }}
                    className="!justify-start"
                    text={t("app_settings_page.buttons.notifications.label")}
                    icon={
                      Notification.permission === "granted" ? (
                        <MdCheckBox
                          size={ICON_SIZES.SM}
                          className="text-lime-400"
                        />
                      ) : (
                        <MdCheckBoxOutlineBlank size={ICON_SIZES.MD} />
                      )
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </TwoSidebars>
  );
};

export default AppPermissionsPage;
